export default {
    /* this mixins is responsible for concatinating error messages from vform and vee-validate  */
    methods: {
        /* errorBag is relataed to veeValidate config name*/
        /* form is related to vform */
        errorMessages(field, errorsArray) {
            if(errorsArray === undefined) errorsArray = this.form.errors
            return this.errors.collect(field).concat(errorsArray.only(field));
        },
        hasErrors(field, errorsArray) {
            if (errorsArray === undefined) errorsArray = this.form.errors
            let errors = this.errors
                .collect(field)
                .concat(errorsArray.only(field));
            if (errors.length > 0) {
                return true;
            }
            return false;
        }
    }
};
